import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { Business } from '../types';
type UseBusinessOptions = {
  businessId?: number;
};
export const getBusiness = ({businessId}: UseBusinessOptions = {}): Promise<Business> => {
  return axios.get(`/business`, {
    params: {},
  });
};

type QueryFnType = typeof getBusiness;
export const useBuisiness = ({businessId}: UseBusinessOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['business'],
    queryFn: () => getBusiness({businessId}),
  });
};
